import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../config/api';
import axios from 'axios';
import { toWords } from 'number-to-words';

import withAuthorization from "../components/authentication";
import Navbar from '../components/Navbar';
import CarData from '../utils/sample.json';
import { numberToWordsIndian } from '../utils/numberToWords';
import { openAndSaveInvoice } from '../utils/openAndSaveInvoice';

const PurchaseDealForm = () => {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [formData, setFormData] = useState({
    carTitle: '',
    carModel: '',
    customerName:'',
    customerAadhaarName:'',
    customerMobile: '',
    whatsappMobile: '',
    customerEmail: '',
    odometerReading: '',
    tokenAmount: '',
    challanAmount:'',
    dealDoneAmount: '',
    carRegistrationNumber: '',
    NocHoldbackAmount:'',
PartipeshiHoldbackAmount:'',
CxBankPaidAmount:'',
AccountholderName:'',
BankACCNo:'',
BankIfsc:'',
CxBankName:'',
LoanPaymentAmount:'',
LoanPaidBy:'Not Applicable',
LoanpaymentStatus:'Not Applicable',
 DueAmount:'',
 PickUpRecievedGD:'',
 AfterPickUpReceivableGD:'',
 paymentSource:''
   
  });

  


  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
   
 
 

  

  const [loading, setLoading] = useState(false);

  // Blocks duplicate submissions; reset automatically when loading clears.
  const submittingRef = useRef(false);
  useEffect(() => {
    if (!loading) submittingRef.current = false;
  }, [loading]);
  
  

const handleSubmit = async (e) => {
  e.preventDefault();
  // Synchronous guard: blocks a second click in the same tick, which a
  // state check cannot do. Prevents duplicate invoices.
  if (submittingRef.current) return;
  submittingRef.current = true;
  setLoading(true); 
  formData.carTitle = Vehicledata.maker_model;
  formData.carModel=Vehicledata.manufacturing_date;
  formData.customerName=Vehicledata.owner_name;
  formData.carRegistrationNumber=Vehicledata.rc_number;
  formData.PickUpRecievedGD = JSON.stringify(selectedField1);
  formData.AfterPickUpReceivableGD = JSON.stringify(selectedField2);
 
  
//generateInvoiceandagreement(formData,tokenCount,Vehicledata);
 try {
  // Send ONLY JSON data (including the vehicleData from the verify API).
  // The backend generates the invoice + agreement PDF and returns its URL.
  const response = await axios.post(
    `${API_BASE_URL}/purchasedeal/submit-Purchase-Deal`,
    { ...formData, vehicleData: Vehicledata },
    { withCredentials: true }
  );

  // Open the invoice in a new tab and save a copy to disk.

  openAndSaveInvoice(response.data);

  // Notify the user
  setSubmissionSuccess(true);

  // Optionally, reset the form
 
} catch (error) {
  console.error('Error submitting token:', error);
  alert('Failed to submit the token application. Please try again.');
}
finally {
 setLoading(false); // Set loading to false after submission completes
}
  
 
};
const[Vehicledata,setVehicledata]=useState({});
const handleSubmit1 = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await fetch(`${API_BASE_URL}/purchasedeal/verify`, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vehicleNumber: formData.carRegistrationNumber })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const CarData = await response.json();

    if (CarData && CarData.result) {
      setVehicledata(CarData.result);
      setfirstpage(false);
    } else {
      console.error('Invalid data format:', CarData);
    }
  } catch (error) {
    console.error('Error fetching vehicle data:', error);
  } finally {
    setLoading(false);
  }
};




  const[firstpage,setfirstpage]=useState(true);
  const [selectedField1, setSelectedField1] = useState([]);
  const [selectedField2, setSelectedField2] = useState([]);

  const options1 = ["Original RC", "Insurance Pdf/harcopy","Bank Noc", "Original Car Key", "Duplicate Car Key" , "form 28","form 29", "form 30","Owner addhar&Pan&Photo"];
  const options2 = ["Original RC", "Insurance Pdf/harcopy","Bank Noc", "Duplicate Car key" , "form 28","form 29", "form 30","Owner addhar&Pan&Photo"];

  const handleChangecheckbox = (e, setState, state) => {
    const { value, checked } = e.target;
    setState(checked ? [...state, value] : state.filter((v) => v !== value));
  };

  formData.DueAmount=Number(formData.dealDoneAmount)-Number(formData.challanAmount)-Number(formData.CxBankPaidAmount)-Number(formData.LoanPaymentAmount)-Number(formData.PartipeshiHoldbackAmount)-Number(formData.NocHoldbackAmount)-Number(formData.tokenAmount);
  return (
    <div><Navbar/><div className="container mx-auto my-10 p-5 border border-gray-300 rounded-lg shadow-lg">
    <h1 className="text-2xl font-bold mb-5">Purchase Deal Form</h1>
    {firstpage ? (<form onSubmit={handleSubmit1}> <div className="mb-4">
        <label className="block text-gray-700">Vehicle Registration Number</label>
        <input
          type="text"
          name="carRegistrationNumber"
          value={formData.carRegistrationNumber}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div>
      <button
        type="submit"
        disabled={loading}
        className="w-full p-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
      >
        {loading ? (
           <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
    {/* Car Animation */}
    <div className="w-28 h-16 flex items-center justify-center mb-4">
      <img
        src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1754381777/Screenshot__620_-removebg-preview_20250805_134123_0000_2_gbdz3h.png"
        alt="Car Logo"
        className="w-36 h-16 animate-carDrive"
      />
    </div>

    {/* Loading Text */}
    <p className="text-xl md:text-2xl font-bold text-gray-800 text-center">
      Getting the {' '}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
        vehicles Details.....
      </span>
    </p>
  </div>
        ) : (
          'Next'
        )}
      </button>
      <h1 className="text-xl font-bold mt-3 text-center">Please click Submit Button Only Once (Avoid double clicks)</h1>
      </div>
      </form>) :
      (<form onSubmit={handleSubmit}>
      <div className="relative w-full p-4 border border-purple-700 rounded mb-6">
      <div className="mb-4 mt-2">
        <label className="block text-gray-700">Car Title</label>
        <input
          type="text"
          name="carTitle"
          value={Vehicledata.maker_model}
         // onChange={handleChange}
         // required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Car Model</label>
        <input
          type="text"
          name="carModel"
          value={Vehicledata.manufacturing_date}
         // onChange={handleChange}
         // required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
     
      <div className="mb-4">
        <label className="block text-gray-700">Customer Name</label>
        <input
          type="text"
          name="customerName"
          value={Vehicledata.owner_name}
          //onChange={handleChange}
          //required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Current Odometer Reading</label>
        <input
          type="number"
          name="odometerReading"
          value={formData.odometerReading}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Current Odometer Reading <strong>in Words</strong></label>
        <input
          type="text"
          name="odometerReadingInWords"
          value={numberToWordsIndian(`${formData.odometerReading}`)}
          readOnly
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Customer Aadhaar Name</label>
        <input
          type="text"
          name="customerAadhaarName"
          value={formData.customerAadhaarName}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">WhatsApp Mobile No.</label>
        <input
          type="number"
          name="whatsappMobile"
          value={formData.whatsappMobile}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Alternate Mobile No.</label>
        <input
          type="number"
          name="customerMobile"
          value={formData.customerMobile}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      
      
      <div className="mb-4">
        <label className="block text-gray-700">Customer Email</label>
        <input
          type="email"
          name="customerEmail"
          value={formData.customerEmail}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Deal Done Amount</label>
        <input
          type="number"
          name="dealDoneAmount"
          value={formData.dealDoneAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Deal Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="Token Amount in Words"
          value={numberToWordsIndian(`${formData.dealDoneAmount}`)}
         
          
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Already Paid Token Amount</label>
        <input
          type="number"
          name="tokenAmount"
          value={formData.tokenAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Already <strong>Paid Token </strong> Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="Token Amount in Words"
          value={numberToWordsIndian(`${formData.tokenAmount}`)}
         
         
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Challan Amount</label>
        <input
          type="number"
          name="challanAmount"
          value={formData.challanAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Challan Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="challan Amount in Words"
          value={numberToWordsIndian(`${formData.challanAmount}`)}
         
          
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      </div>
      <div className="relative w-full p-4 border border-gray-700 rounded">
      <strong className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-white px-1 text-xl font-bold  mt-3">Payment Details</strong>
      <div className="relative w-full p-4 border border-blue-500 rounded mt-8">
      <div className="mb-4 mt-3">
        <label className="block text-gray-700">NOC Holdback Amount</label>
        <input
          type="number"
          name="NocHoldbackAmount"
          value={formData.NocHoldbackAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">NOC holdback Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="NocHoldback Amount in Words"
          value={numberToWordsIndian(`${formData.NocHoldbackAmount}`)}
         
          
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Partipeshi Holdback Amount</label>
        <input
          type="number"
          name="PartipeshiHoldbackAmount"
          value={formData.PartipeshiHoldbackAmount}
          onChange={handleChange}
          
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Partipeshi Holdback Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="Partipeshi Holdback Amount in Words"
          value={numberToWordsIndian(`${formData.PartipeshiHoldbackAmount}`)}
         
          
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div></div>
      
      

               <div className="relative w-full p-4 border border-red-500 rounded">
               <div className="mb-4 mt-2">
        <label className="block text-gray-700">Amount Paid to Customer Bank A/C</label>
        <input
          type="number"
          name="CxBankPaidAmount"
          value={formData.CxBankPaidAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700"> Amount Paid to <strong>Customer Bank</strong> A/C <strong>in Words</strong> </label>
        <input
          type="text"
          name="Cx Bank Paid Amount in Words"
          value={numberToWordsIndian(`${formData.CxBankPaidAmount}`)}
         
         
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Bank A/C Holder Name</label>
        <input
          type="text"
          name="AccountholderName"
          value={formData.AccountholderName}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Bank A/C Number</label>
        <input
          type="number"
          name="BankACCNo"
          value={formData.BankACCNo}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Bank IFSC</label>
        <input
          type="text"
          name="BankIfsc"
          value={formData.BankIfsc}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Cx Bank Name</label>
        <input
          type="text"
          placeholder='eg. hdfc/axis/bankofbaroda/etc.'
          name="CxBankName"
          value={formData.CxBankName}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>

      

               </div>
      

<div className = "relative w-full p-4 border border-green-700 rounded">
<div className="mb-4 mt-2">
        <label className="block text-gray-700">Loan Payment Amount</label>
        <input
          type="number"
          name="LoanPaymentAmount"
          value={formData.LoanPaymentAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700"> Loan Payment Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="LoanPaymentAmount"
          value={numberToWordsIndian(`${formData.LoanPaymentAmount}`)}
         
         
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>

      <div className="mb-4">
  <label className="block text-gray-700">Loan Paid By</label>
  <select
    name="LoanPaidBy"
    value={formData.LoanPaidBy}
    onChange={handleChange}
    required
    className="w-full p-2 border border-gray-300 rounded mt-2"
  >
  <option value="Customer">Customer</option>
    <option value="Car Swipe">Car Swipe</option>
    <option value="Not Applicable">Not Applicable</option>
  </select>
</div>
      <div className="mb-4">
  <label className="block text-gray-700">Loan Payment Status</label>
  <select
    name="LoanpaymentStatus"
    value={formData.LoanpaymentStatus}
    onChange={handleChange}
    required
    className="w-full p-2 border border-gray-300 rounded mt-2"
  >
     <option value="Paid">Paid</option>
    <option value="Pending">Pending</option>
    <option value="Not Applicable">Not Applicable</option>
  </select>
</div></div>



      
      <div className = "relative w-full p-4 border border-purple-700 rounded">
      



      <div className="mb-4">
        <label className="block text-gray-700"> Due of Customer - <strong>(except holdback) </strong> </label>
        <input
          type="number"
          name="DueAmount"
          value={Number(formData.DueAmount)}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div></div>
      <div className="relative w-full  border border-green-700 rounded  mx-auto p-6 bg-white shadow-lg">
      <h2 className="text-xl font-bold text-gray-800 mb-4">BUYING DOCKET </h2>

      {/* First Checkbox Group */}
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-700 mb-2">1.   Pick Up Recieved Docs & goods</h3>
        <div className="space-y-2">
          {options1.map((opt) => (
            <label
              key={opt}
              className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition hover:bg-blue-50"
            >
              <input
                type="checkbox"
                value={opt}
                onChange={(e) => handleChangecheckbox(e, setSelectedField1, selectedField1)}
                checked={selectedField1.includes(opt)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-gray-800">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Second Checkbox Group */}
      <div>
        <h3 className="text-lg font-medium text-gray-700 mb-2"><strong>2.   After Pick Receiable </strong> Docs & goods</h3>
        <div className="space-y-2">
          {options2.map((opt) => (
            <label
              key={opt}
              className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition hover:bg-blue-50"
            >
              <input
                type="checkbox"
                value={opt}
                onChange={(e) => handleChangecheckbox(e, setSelectedField2, selectedField2)}
                checked={selectedField2.includes(opt)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-gray-800">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      
      
    </div>
      </div>
      
      <div className="relative w-full p-4 border border-yellow-600 rounded mt-6">
        <div className="mb-2">
          <label className="block text-gray-700 font-semibold">PAYMENT SOURCE</label>
          <select
            name="paymentSource"
            value={formData.paymentSource}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-2"
          >
            <option value="">Select Payment Source</option>
            <option value="TRUST N RIDE">TRUST N RIDE</option>
            <option value="Car Swipe">Car Swipe</option>
            <option value="TRUST N RIDE + CAR SWIPE">TRUST N RIDE + CAR SWIPE</option>
          </select>
        </div>
      </div>

      
      
      <div>
      <button
        type="submit"
        disabled={loading}
        className="w-full p-3 mt-5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
      >
        {loading ? (
         <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
    {/* Car Animation */}
    <div className="w-28 h-16 flex items-center justify-center mb-4">
      <img
        src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1754381777/Screenshot__620_-removebg-preview_20250805_134123_0000_2_gbdz3h.png"
        alt="Car Logo"
        className="w-36 h-16 animate-carDrive"
      />
    </div>

    {/* Loading Text */}
    <p className="text-xl md:text-2xl font-bold text-gray-800 text-center">
      Purchase Deal Form{' '}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
        is Submitting......
      </span>
    </p>
  </div>
        ) : (
          'Submit Purchase Deal Form'
        )}
      </button>
      
    </div>
    </form>)
    
    
    }
    {submissionSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-semibold text-green-600">Purchase Deal Form Submitted Successfully!</h2>
            <p className="mt-2 text-gray-700">THANK YOU.</p>
            <button
              onClick={() => setSubmissionSuccess(false)}
              className="mt-4 px-6 py-2 bg-blue-500 text
              white rounded-lg hover:bg-blue-600 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}



  </div></div>
  );
};

export default   withAuthorization(PurchaseDealForm, ["admin", "Employee"]);
